<div class="container-fluid">
    <div class="col-md-12" *ngIf="isLoading">
        <app-busy [message]="message"></app-busy>
    </div>
    
    <div class="page_header unassigned_header">
        <button type="button" class="btn_back" (click)="backToList()">
            <img src="assets/img/arrow-back.svg" alt="" />
            Back
          </button>
        <h1 class="heading">Unassigned Activity</h1>
    </div>
    
    <div class="row">
        <div class="col">
          <app-filter
            [formConfig]="filterConfig"
            (formValueChanged)="applyFilter($event)"
            [selectedItems]="selectedItems"
          ></app-filter>
        </div>
      </div>
    <div class="table-responsive">
        <table class="table table-sm custom_table">
            <thead class="thead-inverse">
                <tr class="hd-clpse">
                    <th>
                        Application Number
                        <i class="fa fa-sort"
                            [ngClass]="{'fa-sort-asc sort-a': (flags.flagAN == 2),'fa-sort-desc sort-d': (flags.flagAN == 3), 'fa-sort':(flags.flagAN == 1) }"
                            (click)="onSort(1)"></i>
                    </th>
                    <th>
                        Carrier
                    </th>
                    <th>
                        Application Type
                        <i class="fa fa-sort"
                            [ngClass]="{'fa-sort-asc sort-a': (flags.flagAT == 2),'fa-sort-desc sort-d': (flags.flagAT == 3), 'fa-sort':(flags.flagAT == 1) }"
                            (click)="onSort(2)"></i>
                    </th>
                    <th>
                        Group Assigned
                        <i class="fa fa-sort"
                            [ngClass]="{'fa-sort-asc sort-a': (flags.flagS == 2),'fa-sort-desc sort-d': (flags.flagS == 3), 'fa-sort':(flags.flagS == 1) }"
                            (click)="onSort(3)"></i>
                    </th>
                    <th>
                        Status
                        <i class="fa fa-sort"
                            [ngClass]="{'fa-sort-asc sort-a': (flags.flagS == 2),'fa-sort-desc sort-d': (flags.flagS == 3), 'fa-sort':(flags.flagS == 1) }"
                            (click)="onSort(3)"></i>
                    </th>
                    <th class="text-right">
                        Date Received
                        <i class="fa fa-sort "
                            [ngClass]="{'fa-sort-asc sort-a': (flags.flagDA == 2),'fa-sort-desc sort-d': (flags.flagDA == 3), 'fa-sort':(flags.flagDA == 1) }"
                            (click)="onSort(4)"></i>
                    </th>
                    <th class="text-center">
                        Assign Activity
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="tbl-row" style="border-bottom: 1px solid #ddd;"
                    *ngFor="let item of activities | orderBy: criteria : direction | paginate: {itemsPerPage:pageSize, currentPage: utility.page ,totalItems: count};let index = index">
                    <td class="bfr-end-col" title="{{item.Name}}">{{item.applicationId}}</td>
                    <td class="bfr-end-col" title="{{item.Name}}">{{item.applicant}}</td>                
                    <td class="bfr-end-col">{{item.applicationType}}</td>
                    <td class="bfr-end-col">{{item.userassigned}}</td>
                    <td class="bfr-end-col">{{item.activityStatus}}</td>
                    <td class="bfr-end-col text-right">{{item.datereceived?.toLocaleString() | date:'dd/MM/yyyy'}}</td>
                    <td class="bfr-end-col text-center">
                        <span>
                            <span title="Process activity" id="processAcc"
                                [ngClass]="{'disabled':item.status_id==1}"
                                class="action_btn" (click)="onProcess(item)">
                                <img src="/assets/permit-viewer2.png" class="permit-view" />
                            </span>
                        </span>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr *ngIf="count > 10" class="pagination_row">
                    <td colspan="8">
                        <div class="row">
                            <div class="col-2">
                                <div class="input-group mb-3 rm-brd"
                                    style="width:125px!important;height:30px!important;">
                                    <div class="input-group-prepend">
                                        <label class="input-group-text form-control-sm show-h"
                                            for="show-id">Show:</label>
                                    </div>
                                    <select class="form-control form-control-sm show-h" id="show-id"
                                        [(ngModel)]="pageSize" (change)="onChange()">
                                        <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-10">
                                <pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)"
                                    style="margin-left:0px!important;float: right !important;"></pagination-controls>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="isEmpty">
                    <td colspan="4" class="rm-brd">
                        <span class="text-info text-small">No activity found.</span>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
    </div>
